(function(){
  var PATH='/pages/wybor-dostawy';
  var ID='plawny-delivery-terms';
  function onPage(){return location.pathname.indexOf(PATH)===0;}
  function btn(){return document.querySelector('.delivery-picker__continue');}
  function box(){return document.getElementById(ID);}
  function ensure(){
    if(!onPage())return;
    var b=btn(); if(!b)return;
    if(!box()){
      var d=document.createElement('div');
      d.className='plawny-delivery-terms';
      d.innerHTML='<input id="'+ID+'" type="checkbox" autocomplete="off"><label for="'+ID+'">Akceptuję Regulamin Sklepu i potwierdzam zapoznanie się z <a href="/pages/polityka-prywatnosci" target="_blank">Polityką prywatności</a>.</label>';
      b.insertAdjacentElement('beforebegin',d);
      var e=document.createElement('div');e.className='plawny-delivery-error';e.textContent='Zaznacz akceptację regulaminu, żeby przejść do płatności.';d.insertAdjacentElement('afterend',e);
    }
  }
  function stop(e){e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();}
  function error(){ensure();var e=document.querySelector('.plawny-delivery-error');if(e)e.classList.add('is-visible');var c=box();if(c)c.focus();}
  document.addEventListener('click',function(e){
    if(!onPage())return;
    if(e.target.closest&&e.target.closest('.plawny-delivery-terms'))return;
    var b=e.target.closest&&e.target.closest('.delivery-picker__continue');
    if(!b)return;
    var c=box();
    if(!c||!c.checked){stop(e);error();return false;}
  },true);
  document.addEventListener('change',function(e){if(e.target&&e.target.id===ID){var er=document.querySelector('.plawny-delivery-error');if(er)er.classList.remove('is-visible');}},true);
  document.addEventListener('DOMContentLoaded',ensure);setInterval(ensure,1000);
})();